import { Add, Delete } from "@mui/icons-material";
import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import { useFieldArray } from "react-hook-form";
import ConfigValidationRuleTypeDialog from "../../useDialogs/ConfigValidationRuleTypeDialog";
import { useDialogs } from "../../useDialogs/useDialogs";
import {
  defaultJsonataValidationRule,
  defaultLLMValidationRule,
} from "./ConfigDefault";
import { useFormConfigContext } from "./ConfigFormContext";
import ConfigValidationRule from "./ConfigValidationRule";

const ConfigValidation: React.FC = () => {
  const { control, setValue } = useFormConfigContext();
  const dialogs = useDialogs();

  const {
    fields: documentRules,
    append: addDocumentRule,
    remove: removeDocumentRule,
  } = useFieldArray({
    control,
    name: "config.validation.document_rules",
  });
  const {
    fields: assetRules,
    append: addAssetRule,
    remove: removeAssetRule,
  } = useFieldArray({
    control,
    name: "config.validation.asset_rules",
  });

  return (
    <>
      <div className="flex justify-between items-center">
        <Typography className="text-xl font-semibold">Validation</Typography>

        <Button
          color="error"
          onClick={() => setValue("config.validation", undefined)}
        >
          <Delete />
        </Button>
      </div>
      <Stack rowGap={2} className="py-4 px-4 overflow-y-scroll">
        {assetRules && (
          <div className="flex justify-between items-center">
            <Typography className="text-lg font-semibold">
              Validations dossier
            </Typography>
            <Button
              size="small"
              variant="contained"
              className="gap-2"
              onClick={() =>
                dialogs.open(ConfigValidationRuleTypeDialog, {
                  addLLMQuery: () => addAssetRule(defaultLLMValidationRule()),
                  addJsonataQuery: () =>
                    addAssetRule(defaultJsonataValidationRule()),
                })
              }
            >
              <Add />
              Validation dossier
            </Button>
          </div>
        )}
        {assetRules?.map((rule, index) => {
          return (
            <ConfigValidationRule
              key={rule.id}
              index={index}
              removeRule={() => removeAssetRule(index)}
              path="asset_rules"
            />
          );
        })}
        {documentRules && (
          <div className="flex justify-between items-center">
            <Typography className="text-lg font-semibold">
              Validations document
            </Typography>
            <Button
              size="small"
              variant="contained"
              className="gap-2"
              onClick={() => addDocumentRule(defaultJsonataValidationRule())}
            >
              <Add />
              Validation document
            </Button>
          </div>
        )}
        {documentRules?.map((rule, index) => {
          return (
            <ConfigValidationRule
              key={rule.id}
              index={index}
              removeRule={() => removeDocumentRule(index)}
              path="document_rules"
            />
          );
        })}
      </Stack>
    </>
  );
};
export default ConfigValidation;
